import { BhSpinnerComponentModule } from 'src/app/components/_core/bh-spinner/bh-spinner.component.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { VerlockerPage } from './verlocker.page';
import { BhAppVersionComponentModule } from 'src/app/components/_core/bh-app-version/bh-app-version.component.module';

const routes: Routes = [
  {
    path: '',
    component: VerlockerPage
  }
];

@NgModule({
  imports: [
    BhAppVersionComponentModule,
    BhSpinnerComponentModule,
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [VerlockerPage],
  entryComponents: []
})
export class VerlockerPageModule {}
